import { css } from '@emotion/react';

export const dealPanelFieldContainerCss = css`
  margin: 0 0.75rem;
`;
